import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@saucelabs/sl-component-buttons';
import { Modal } from '@saucelabs/sl-component-overlay';
import modalConnect from '@saucelabs/sl-container-modal';
import { ControlLabel, FormGroup, FormControl, HelpBlock } from '@saucelabs/sl-component-form';

import { TOOLBAR_TRACKING_NAMES, trackEvent } from './../../tracking';
import { CONFIGURATION_DEVICE_TYPES, CONFIGURATION_TEST_TYPES } from '../../constants';

const EXECUTE_ADB_SHELL_MODAL_KEY = 'executeADBShellModal';

class ExecuteADBShellModal extends Component {
  handleConfirm = () => {
    const { onConfirm, onHide, testType } = this.props;

    onConfirm(this.input.value);
    onHide();
    this.input.value = '';

    trackEvent(TOOLBAR_TRACKING_NAMES.ADB_SHELL_EXECUTE, {
      deviceType: CONFIGURATION_DEVICE_TYPES.REAL_DEVICE,
      testType,
    });
  }

  render() {
    const { onHide, show } = this.props;

    return (
      <Modal
        onHide={onHide}
        show={show}
      >
        <Modal.Header>
          <Modal.Title>Execute ADB Command</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup>
            <ControlLabel>ADB command</ControlLabel>
            <FormControl
              inputRef={(input) => {
                this.input = input;
              }}
              placeholder="ADB command"
              type="text"
            />
            <HelpBlock>{'Type input text \'abc\' for command adb shell input text \'abc\'.'}</HelpBlock>
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button
            category="default"
            material
            onClick={onHide}
            size="sm"
          >
            Cancel
          </Button>
          <Button
            category="action"
            material
            onClick={this.handleConfirm}
            raised
            size="sm"
          >
            Execute
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

ExecuteADBShellModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  testType: PropTypes.oneOf([
    CONFIGURATION_TEST_TYPES.APP,
    CONFIGURATION_TEST_TYPES.WEB,
  ]).isRequired,
};

export default modalConnect(EXECUTE_ADB_SHELL_MODAL_KEY, ExecuteADBShellModal);
export {
  ExecuteADBShellModal,
  EXECUTE_ADB_SHELL_MODAL_KEY,
};
